module.exports = __webpack_public_path__ + "static/media/fleet-parking-management.89935412.svg";